<template>
  <v-menu
    close-on-content-click
    left
    max-height="400px"
    offset-y
    :value="menu"
    @update:menu="changeMenuState">
    <template #activator="{ on }">
      <div class="flex flex-direction-column">
        <v-chip
          class="black--text  menu open-folter-dialog-chip"
          :disabled="disabled"
          :title="tooltip"
          v-on="on">
          {{ text }}
          <sIcon
            class="my-auto"
            size="10"
            type="arrow"/>
        </v-chip>
        <sProgress
          v-if="loading"
          class="ml-4 width-85 mb-0"
          indeterminate
          style="position: relative; top: -5px;"/>
      </div>
    </template>
    <div
      class="statuses-menu menu list menu py-2 px-3"
      data-qa="filters-menu-list">
      <v-checkbox
        v-for="status in statuses"
        :key="`${status[item_key] || status}-key`"
        v-model="filtredItems"
        :class="{'active-item' : !multiple && item.search === status[item_key]}"
        color="var(--black-color)"
        data-qa="statuses-menu-item"
        hide-details
        :ripple="false"
        :value="status">
        <template #label>
          <span class="status-title black--text h7-text">
            {{ status[item_title] || status }}
          </span>
        </template>
      </v-checkbox>
    </div>
  </v-menu>
</template>
<script>
import { modalMixin } from 'mixins'

export default {
  name: 'statuses',
  mixins: [modalMixin],
  data() {
    return {
      filtredItems: [],
      statuses: [],
      loading: false,
      menu: false
    }
  },
  props: {
    item: Object,
    type: String,
    disabled: Boolean,
    /**
     * Свойство из справочника с ключем
     */
    item_key: String,
    /**
     * Свойство из справочника с текстом
     */
    item_title: String,
    /**
     * Данные справочника
     */
    setItems: [Function, Array],
    multiple: {
      type: Boolean,
      default: true
    },
    updateOnOpen: Boolean
  },
  async created() {
    await this.getItems()
  },
  computed: {
    elem: {
      get() {
        return this.item
      },
      set(value) {
        this.$emit('update:item', value)
      }
    },
    tooltip() {
      if (!this.multiple) {
        if (!this.filtredItems) {
          return this.$t('Purchasing.All')
        }
        const item = this.setItems.find(i => i[this.item_key] === this.filtredItems[this.item_key])
        return item ? item[this.item_title] : ''
      }
      return this.filtredItems?.length ? this.filtredItems.map(el => el[this.item_title]).join(', \n') : ''
    },
    text() {
      if (!this.multiple) {
        if (!this.filtredItems) {
          return this.$t('Purchasing.All')
        }
        const item = this.setItems.find(i => i[this.item_key] === this.filtredItems[this.item_key])
        return item ? item[this.item_title] : this.filtredItems
      }
      const firstItemLabel = this.filtredItems?.length == 0 ? this.$t('Purchasing.All') : (this.filtredItems[0] && this.filtredItems[0][this.item_title]) || this.filtredItems[0]
      let text = this.filtredItems?.length > 1
        ? this.filtredItems?.length + ' ' + (!this.type || this.type == 'tenderStatusTitle' ? this.$t('Purchasing.Statuses') : this.$t('Tenders.Types'))
        : firstItemLabel
      return text
    },
  },
  methods: {
    async getItems() {
      this.loading = true
      if (Array.isArray(this.setItems)) {
        this.statuses = this.setItems
      } else {
        await this.setItems(this.type).then(res => this.statuses = res || [])
      }

      if (this.multiple && this.elem.search?.length) {
        this.filtredItems = this.statuses.filter(el => this.elem.search.find(it => it == ( el[this.item_key] || el ) ) )
        if (!this.filtredItems?.length) {
          this.elem.search = []
          this.$emit('toggleClear')
        }
      } else if (!this.multiple && this.elem.search) {
        this.filtredItems = this.statuses.find(el => el[this.item_key] ===  this.elem.search)
        if (!this.filtredItems) {
          this.$emit('update:model', null)
          this.$emit('toggleClear')
        }
      }
      this.loading = false
    },
    changeMenuState(state) {
      if (this.updateOnOpen && state) { // для обновлення масиву можливих об'єктів якшо змінилась організація
        this.getItems()
      }
      this.menu = state
    }
  },
  watch: {
    filtredItems(val, old) {
      if (this.$_.differenceWith( val , old, this.$_.isEqual).length
        || val?.length != old?.length) {
        const result = this.$_.cloneDeep(this.elem)
        if (this.multiple) {
          result.search = val?.map(el => (el && el[this.item_key]) || el)
          //this.$emit('apply', this.elem.search)
        } else {
          result.search = val ? val[this.item_key] : null
          //this.$emit('apply', this.elem.search)
        }
        this.elem = result
        this.$emit('toggleClear')
      }
    },
    /*menu(val) {
      if (this.updateOnOpen && val) { // для обновлення масиву можливих об'єктів якшо змінилась організація
        this.getItems()
      }
    },*/
    setItems: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.getItems()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.active-item {
  background: var(--color-main-green);
}
.active-item:hover,
.active-item:focus {
  background: var(--color-main-green);
}
.statuses-menu.list {
  .status-title  {
    line-height: 17px;
  }
  .v-input--checkbox {
    margin-top: 0 !important;
    &:first-child {
      padding-top: 0 !important;
    }
    &:not(:first-child) {
      padding-top: 10px !important;
    }
  }
}
.chip {
  background-color: #E4E4E4;
  height: 36px
}
</style>
